import React from 'react';
import usePlatform from '~/hooks/usePlatform';
import useRemotePickMealPoints from '~/hooks/useRemotePickMealPoints';
import useCustomer from '~/hooks/useCustomer';

type PlatformProviderProps = {
  children: React.ReactElement | null;
};

export default function PlatformProvider({ children }: PlatformProviderProps) {
  usePlatform();
  useRemotePickMealPoints();
  useCustomer();

  return children;
}
